import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { Plan, Product } from '@bytel/bytel-sales';
import { UPDATE_ACTIONS } from '@bytel/checkout';

import { ProductHelper } from '@base/catalog/product-helper';
import { TrustHtmlPipe } from '@base/common/pipes/trustHtml.pipe';

import { MainCartService } from '@services/main-cart.service';

import { AddProductConfig, BasicObject, RemoveProductConfig } from '@interfaces/checkout.interface';

import { PriceWithoutCouponPipe } from '@shared/pipes/price-without-coupon.pipe';

import { PriceComponent } from 'src/app/trilogy/price/price.component';

import { LazyLoadImageModule } from 'ng-lazyload-image';

@Component({
    selector: 'checkout-crosssell-item',
    templateUrl: './crosssell-item.component.html',
    styleUrl: 'crosssell-item.component.scss',
    standalone: true,
    imports: [CommonModule, LazyLoadImageModule, TrustHtmlPipe, FormsModule, PriceComponent, PriceWithoutCouponPipe],
})
export class CrosssellItemComponent implements OnInit {
    @Input() public product: Product;
    @Input() public totalProductsQty: number;
    @Input() public quoteIndex: number;

    public TYPES: BasicObject = {
        option_salable: 'option_salable',
        accessory: 'accessory',
    };
    public UPDATE_ACTION: BasicObject = UPDATE_ACTIONS;
    public currentQty: number = 1;
    public maxItemsQty: number = 0;
    public data: BasicObject = {};
    public defaultImage: string;
    public images: string;
    public productMaxQty: number[] = [];
    public canBeRemoved: boolean = true;

    @Output() public removeProductEvent = new EventEmitter<RemoveProductConfig>();
    @Output() public addProductEvent = new EventEmitter<AddProductConfig>();

    constructor(
        private productHelper: ProductHelper,
        private cartService: MainCartService,
    ) {}

    public get type(): string {
        return this.TYPES[this.product.data.type_id];
    }

    ngOnInit(): void {
        this.data = this.product.data;
        this.defaultImage = this.productHelper.getDefaultImage(this.product);
        this.images = this.productHelper.getImages(this.product);
        this.currentQty = this._getQty();
        this.cartService.cartQuoteSubscription.subscribe(() => this._refreshProductsQuantities());
        this.productMaxQty = this._getSelectQuantityOptions();
        this.maxItemsQty = this.product.rules?.maxQuantity;
        const quote = this.cartService.getQuote(this.quoteIndex);
        const plan = quote.getPrincipalProduct<Plan>('Plan');
        this.canBeRemoved = !plan?.autoAdd?.includes(this.data.gencode);
    }

    public removeItem(): void {
        if (this.canBeRemoved) {
            this.removeProductEvent.emit({
                product: this.product,
                removeAll: true,
            });
        }
    }

    public updateItem(): void {
        this.addProductEvent.emit({
            product: this.product,
            qty: +this.currentQty,
        });
    }

    private _refreshProductsQuantities(): void {
        this.currentQty = this._getQty();
    }

    private _getQty(): number {
        return this.cartService.getProductQty(this.product);
    }

    private _getSelectQuantityOptions(): number[] {
        const qtyOptionList = [];

        for (let i = 1; i <= this.product.maxQty; i++) {
            qtyOptionList.push(i);
        }

        return qtyOptionList;
    }
}
